import { ChefId } from '@/types/chef';

export interface ChefLoadingTheme {
  id: ChefId;
  displayName: string;
  gradient: string;
  particleColors: string[];
  messages: string[];
  completionMessage: string;
}

export const chefLoadingThemes: Record<ChefId, ChefLoadingTheme> = {
  TestKitchenScientist: {
    id: 'TestKitchenScientist',
    displayName: 'Test Kitchen Scientist',
    gradient: 'from-emerald-500 to-teal-600',
    particleColors: ['#10B981', '#14B8A6', '#06B6D4', '#0EA5E9'],
    messages: [
      'Analyzing optimal ingredient ratios...',
      'Testing for foolproof results...',
      'Engineering the perfect technique...',
      'Validating cooking times...',
      'Refining for home kitchen success...'
    ],
    completionMessage: 'Recipe validated and ready!'
  },
  TheVitalityChef: {
    id: 'TheVitalityChef',
    displayName: 'Vitality Chef',
    gradient: 'from-green-400 to-emerald-600',
    particleColors: ['#22C55E', '#10B981', '#84CC16', '#A3E635'],
    messages: [
      'Selecting nutrient-dense ingredients...',
      'Optimizing for your dietary needs...',
      'Balancing macros for vitality...',
      'Enhancing natural flavors...',
      'Maximizing nutritional value...'
    ],
    completionMessage: 'Nourishing recipe crafted!'
  },
  TheElementalChef: {
    id: 'TheElementalChef',
    displayName: 'Elemental Chef',
    gradient: 'from-amber-400 to-orange-600',
    particleColors: ['#F59E0B', '#D97706', '#EA580C', '#FBBF24'],
    messages: [
      'Sourcing seasonal ingredients...',
      'Honoring ingredient purity...',
      'Applying foundational techniques...',
      'Letting natural flavors shine...',
      'Perfecting the balance...'
    ],
    completionMessage: 'Pure, elemental recipe ready!'
  },
  TheCulinaryAlchemist: {
    id: 'TheCulinaryAlchemist',
    displayName: 'Culinary Alchemist',
    gradient: 'from-purple-500 to-pink-600',
    particleColors: ['#A855F7', '#D946EF', '#EC4899', '#F472B6'],
    messages: [
      'Transforming humble ingredients...',
      'Discovering hidden potential...',
      'Working culinary magic...',
      'Creating surprising flavors...',
      'Elevating the ordinary...'
    ],
    completionMessage: 'Magical transformation complete!'
  },
  TheHeritageChef: {
    id: 'TheHeritageChef',
    displayName: 'Heritage Chef',
    gradient: 'from-lime-500 to-green-600',
    particleColors: ['#84CC16', '#22C55E', '#16A34A', '#4ADE80'],
    messages: [
      'Honoring ancestral techniques...',
      'Balancing traditional flavors...',
      'Sourcing authentic ingredients...',
      'Preserving culinary heritage...',
      'Sharing cultural wisdom...'
    ],
    completionMessage: 'Traditional recipe perfected!'
  },
  TheEssentialistChef: {
    id: 'TheEssentialistChef',
    displayName: 'Essentialist Chef',
    gradient: 'from-slate-400 to-gray-600',
    particleColors: ['#94A3B8', '#64748B', '#475569', '#6B7280'],
    messages: [
      'Distilling to essentials...',
      'Selecting perfect ingredients...',
      'Removing the unnecessary...',
      'Achieving purity of flavor...',
      'Less is more...'
    ],
    completionMessage: 'Essence captured perfectly!'
  }
};

export const getChefLoadingTheme = (chefId: ChefId | string): ChefLoadingTheme => {
  return chefLoadingThemes[chefId as ChefId] || chefLoadingThemes.TheCulinaryAlchemist;
};
